import { Component, OnInit, HostBinding, Inject } from '@angular/core';
import { LoginService, navigatorOnline$ } from 'projects/core/src/public-api';
import { AppStateQuery } from './data/app-state.query';
import { HttpErrorService } from 'projects/core/src/lib/core/data/http-error.service';
import { WsService } from 'projects/app-misc/src/app/modules/data/ws.service';
import { filter, map } from 'rxjs/operators';
import { timer, Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { OverlayPanel } from 'primeng/overlaypanel';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CalendarOptions } from '@fullcalendar/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import Handsontable from 'handsontable';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [DeviceDetectorService]
})
export class AppComponent implements OnInit {
  title = 'desktop';

  initialized$ = this.appStateQuery.initialized$;

  authorized$ = this.appStateQuery.authorized$;

  online$ = this.appStateQuery.online$;

  opSubs: Subscription;

  dev = environment.dev


  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth'
  };

  urlLink: string;
  blobUrl: any;


  constructor(
    protected httpErrorService: HttpErrorService,
    protected snackBar: MatSnackBar,
    protected loginService: LoginService,
    protected appStateQuery: AppStateQuery,
    protected wsService: WsService,
    private deviceService: DeviceDetectorService,
    @Inject(DOCUMENT) private document: Document
  ) {
  }

  ngOnInit() {
    this.loginService.checkStatus()

    this.detectDevice()

    this.httpErrorService
    .error$
    .subscribe(error => {
      this.snackBar.open(`Server error`, null, {
        duration: 5000,
        panelClass: ['http-error']
      });
    })

    this.appStateQuery
    .authorized$
    .pipe(
      filter(authorized => authorized)
    )
    .subscribe(authorized => {
      this.wsService.connectToSocket()
    })
  }

  detectDevice() {
    if(this.deviceService.isDesktop()) {
      this.document.body.classList.add('is-desktop')
    }
    if(this.deviceService.isMobile()) {
      this.document.body.classList.add('is-mobile')
    }
    if(this.deviceService.isTablet()) {
      this.document.body.classList.add('is-tablet')
    }
  }

  getProjects(day: number) {
    return day
  }

  showOP(op: OverlayPanel, event: MouseEvent) {
    this.opSubs = timer(100).subscribe(emit => {

      // this.projectService

      // tslint:disable-next-line: deprecation
      op.show(null, event.srcElement);
      // this.projectService.getShortProject(this.project.id)
    })
  }

  hideOP(op: OverlayPanel) {
    this.opSubs.unsubscribe();

    timer(500).subscribe(emit => {
      op.hide();
    })
  }

}
